const root = `td-register/exportExcel/`
const urls = {
  queryGeneralPunishExport: root + 'queryGeneralPunishExport',
  queryDaysPenaExport: root + 'queryDaysPenaExport',
  querySealUpExport: root + 'querySealUpExport',
  queryLimitStopExport: root + 'queryLimitStopExport',
  queryDetentiontExport: root + 'queryDetentiontExport',
  queryPolluteCrimeExport: root + 'queryPolluteCrimeExport',
  queryApplyEnforceExport: root + 'queryApplyEnforceExport',
  queryNoPunishExport: root + 'queryNoPunishExport'
}
//导出一般行政处罚
export const queryGeneralPunishExport = obj => {
  return $http.downloadByPost(urls.queryGeneralPunishExport, obj)
}
//按日连续处罚导出接口
export const queryDaysPenaExport = obj => {
  return $http.downloadByPost(urls.queryDaysPenaExport, obj)
}

//查封、扣押导出接口
export const querySealUpExport = obj => {
  return $http.downloadByPost(urls.querySealUpExport, obj)
}
//停产导出接口
export const queryLimitStopExport = obj => {
  return $http.downloadByPost(urls.queryLimitStopExport, obj)
}
//行政拘留环境违法导出接口
export const queryDetentiontExport = obj => {
  return $http.downloadByPost(urls.queryDetentiontExport, obj)
}
//涉嫌环境违法犯罪导出接口
export const queryPolluteCrimeExport = obj => {
  return $http.downloadByPost(urls.queryPolluteCrimeExport, obj)
}
//涉嫌环境违法犯罪导出接口
export const queryApplyEnforceExport = obj => {
  return $http.downloadByPost(urls.queryApplyEnforceExport, obj)
}
//不予处罚
export const queryNoPunishExport = obj => {
  return $http.downloadByPost(urls.queryNoPunishExport, obj)
}

export default {
  queryGeneralPunishExport,
  queryDaysPenaExport,
  querySealUpExport,
  queryLimitStopExport,
  queryDetentiontExport,
  queryPolluteCrimeExport,
  queryApplyEnforceExport,
  queryNoPunishExport
}
